import React from "react"
import { Reveal, Fade } from "react-reveal"
import styles from "../styles/components/text-box.module.scss"
import Flag1 from "../images/text-box-flag-1.svg"
import Flag2 from "../images/text-box-flag-2.svg"
import "../styles/animations.scss"

const TextBox = props => {
  return (
    <div className={styles.background}>
      <Fade left>
        {/* svg requires wrapper div for correct positioning */}
        <div id={styles.flag1}>
          <Flag1 />
        </div>
      </Fade>
      <Fade left>
        <div id={styles.flag2}>
          <Flag2 />
        </div>
      </Fade>
      <div className={styles.contentContainer}>
        <Reveal effect="fadeIn">
          <div className={styles.header}>{props.header}</div>
        </Reveal>
        <div className={styles.textContainer}>
          {props.textBlockList.map((textBlock, i) => {
            return (
              <div className={styles.textBlock} key={i}>
                <Reveal effect="fadeIn" duration={400}>
                  <div className={styles.title}>{textBlock.title}</div>
                </Reveal>
                <Reveal effect="fadeInUp">
                  <div className={styles.body}>{textBlock.body.body}</div>
                </Reveal>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default TextBox
